/** Minimal HTML whitelist for back-office rich text (admin-authored content). */
const ALLOWED = /^(b|strong|i|em|u|br|a|span|p)$/i;

export function sanitizeHtml(html) {
  if (!html || typeof html !== "string") return "";
  if (typeof window === "undefined" || !window.DOMParser) return html;
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const root = doc.body.firstChild;

  const walk = (node) => {
    [...node.children].forEach((el) => {
      if (!ALLOWED.test(el.tagName)) {
        el.replaceWith(...el.childNodes);
        return;
      }
      [...el.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const keep =
          (el.tagName.toLowerCase() === "a" && (name === "href" || name === "target" || name === "rel"));
        if (!keep) el.removeAttribute(attr.name);
      });
      if (el.tagName.toLowerCase() === "a") {
        const href = el.getAttribute("href") || "";
        if (/^\s*javascript:/i.test(href)) el.removeAttribute("href");
        if (/^https?:\/\//i.test(href)) {
          el.setAttribute("target", "_blank");
          el.setAttribute("rel", "noopener noreferrer");
        }
      }
      walk(el);
    });
  };

  walk(root);
  return root.innerHTML;
}

export const hasHtml = (v) => typeof v === "string" && /<\/?[a-z][\s\S]*>/i.test(v);
